import { InstantConfigSettingsRepository } from "@wikia/instant-config-loader";
import { TopLevelDomainExtractor } from "@identity/utils";
import {
  CommunicationService,
  eventsRepository,
} from "../CommunicationService";

export class SettingsRepositoryCookieImpl
  implements InstantConfigSettingsRepository
{
  private readonly topLevelDomain: string;
  constructor(
    private readonly cookiesManager: CookiesManager,
    private readonly communicationService: CommunicationService,
    window: Window,
  ) {
    this.topLevelDomain = TopLevelDomainExtractor.extract(
      window.location.hostname,
    );
  }

  get(key: string): string | undefined {
    return this.cookiesManager.get(key);
  }

  remove(key: string): any {
    this.cookiesManager.remove(key, {
      domain: this.topLevelDomain,
    });
  }

  set(key: string, value: string, ttl?: number): any {
    this.communicationService.on(
      eventsRepository.CONSENT_READY,
      (consents: Consents) => {
        if (
          !(consents.geoRequiresSignal && consents.ccpaSignal) &&
          !(consents.geoRequiresConsent && !consents.gdprConsent)
        ) {
          const options: CookieAttributes = {
            domain: this.topLevelDomain,
          };
          if (ttl) {
            options.expires = ttl;
          }
          this.cookiesManager.set(key, value, options);
        }
      },
    );
  }
}
